<template>
  <div class="content-card-1">
    <img class="content-card-1-image" :src="content.thumbnail" :alt="content.title">
    <h6 class="content-card-1-title">{{ content.title }}</h6>
    <div class="content-card-1-body" v-html="content.body"></div>
    <m-a  class="text-decoration-none" :href="findLinkOnContent(content.abstraction)">
      <div class="content-card-1-button" v-t="`content.card.more`"></div>
    </m-a>
  </div>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard2 from '../../Cards/Card2'
import mA from '../../Tags/A'

export default {
  name: "ContentCard300",
  components: {mCard2, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  }
}
</script>

<style scoped>
.content-card-1-image {
  height: 350px;
  width: 100%;
  object-fit: contain;
}
</style>